import { useState, useEffect } from "react";
import { TratamientoAdminCreate } from "./TratamientoAdminCreate";
import { useLoaderData, useParams } from "react-router-dom";
import Select from "react-select";

import { OpcionesEstadosTratamientos } from './OpcionesEstadosTratamientos';

import { GetAndUpdateUser } from "./GetAndUpdateUser";
import { AccesoCreate, AccesoSchedule } from "./AccesoCreate";

import * as API from "../services/especialistas";

export function TratamientoAdminNew() {
  const paciente = useLoaderData();
  console.log(paciente.id)

  let pacienteNiceName = paciente.last_name + ", " + paciente.first_name;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [date, setDate] = useState(todayDate);
  const [estado, setEstado] = useState("");

  let slug = "tr-us-" + paciente.id + "-fe-" + date;

  const [loading, setLoading] = useState(false);
  const [especialistas, setEspecialistas] = useState([]);

  const [medico, setMedico] = useState([]);
  const [psicologo, setPsicologo] = useState([]);
  const [nutricion, setNutricion] = useState([]);
  const [entrenamiento, setEntrenamiento] = useState([]);
  const [mindfulness, setMindfulness] = useState([]);

  const [medicoSelected, setMedicoSelected] = useState([]);
  const [psicoHospSelected, setPsicoHospSelected] = useState([]);
  const [psicologoSelected, setPsicologoSelected] = useState([]);
  const [nutricionSelected, setNutricionSelected] = useState([]);
  const [entrenamientoSelected, setEntrenamientoSelected] = useState([]);
  const [mindfulnessSelected, setMindfulnessSelected] = useState([]);

  const [especialistasSelected, setEspecialistasSelected] = useState([]);

  // 1.Load all Especialistas
  useEffect(() => {
    const loadEspecialistas = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);

      // Await make wait until that
      // promise settles and return its result
      const response = await API.getAllEspecialistas();
      console.log(response);

      // After fetching data stored it in posts state.
      setEspecialistas(response);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadEspecialistas();
  }, []);

  // 2.Map all Especialistas by especialidad to create the options for multiselect
  useEffect(() => {
    const medicinalist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "medicina")
    );
    const medicinaListSelect = medicinalist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setMedico(medicinaListSelect);
    console.log(medicinaListSelect);

    const psicologialist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "psicologia")
    );
    const psicologiaListSelect = psicologialist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setPsicologo(psicologiaListSelect);

    const nutricionlist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "nutricion")
    );
    const nutricionListSelect = nutricionlist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setNutricion(nutricionListSelect);

    const entrenamientolist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "entrenamiento")
    );
    const entrenamientoListSelect = entrenamientolist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setEntrenamiento(entrenamientoListSelect);

    const mindfulnesslist = especialistas.filter(item =>
      item.meta.especialidad && Array.isArray(item.meta.especialidad) &&
      item.meta.especialidad.some(espec => espec.value === "mindfulness")
    );
    const mindfulnessListSelect = mindfulnesslist.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));
    setMindfulness(mindfulnessListSelect);
  }, [especialistas]);

  // 3.Create an array of Ids of selected Especialistas
  useEffect(() => {
    const allSelected = medicoSelected.concat(
      psicoHospSelected,
      psicologoSelected,
      nutricionSelected,
      entrenamientoSelected,
      mindfulnessSelected
    );
    const allSelectedId = allSelected.map((field) => field.value);

    setEspecialistasSelected(allSelectedId.toString());
  }, [
    medicoSelected,
    psicoHospSelected,
    psicologoSelected,
    nutricionSelected,
    entrenamientoSelected,
    mindfulnessSelected,
  ]);

  const submitTreatment = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
  
    // Se fija el scheduleDate a las 08:30 AM, sin depender de citaHora
  const scheduleDate = `${date}T08:30:00`;

  // Obtenemos la fecha actual
  const now = new Date();

  // Convertimos la fecha ingresada (se asume formato "YYYY-MM-DD") en un objeto Date
  const inputDate = new Date(date);

  // Creamos objetos que representan únicamente la fecha (sin la hora) para comparar
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateToCompare = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());

  // Si la fecha ingresada es mayor que hoy (sin contar la hora), es una fecha futura
  const isFutureDate = dateToCompare > today;
  
    try {
      let acceso;
        if (isFutureDate) {
          acceso = await AccesoSchedule(
            paciente.id,
            date,
            scheduleDate, // Se utiliza solo la fecha
          );
        } else {
          acceso = await AccesoCreate(
            paciente.id,
            date,
          );
        }
        console.log('Acceso creado:', acceso);
  
      const tratamiento = await TratamientoAdminCreate(
        paciente.id,
        date,
        estado,
        slug,
        medicoSelected,
        psicoHospSelected,
        psicologoSelected,
        nutricionSelected,
        entrenamientoSelected,
        mindfulnessSelected,
        especialistasSelected,
        acceso.id
      );
  
      const newTratamientoId = tratamiento.id;
      await GetAndUpdateUser(paciente.id, newTratamientoId, false);
  
      // Redirigir al tratamiento creado
      window.location.replace(`../tratamientos/${newTratamientoId}`);
    } catch (error) {
      console.error('Error general:', error);
    } finally {
      setIsCreatingButton(false);
    }
  };
  


  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitTreatment}>
          <h3>Crear Tratamiento</h3>
          <div className='field'>
            <label htmlFor='user'>Paciente</label>
            <div className='control'>
              <input
                className='input'
                id='user'
                required
                disabled
                readOnly
                type='text'
                value={pacienteNiceName}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='date'>Fecha</label>
            <div className='control'>
              <input
                className='input'
                id='date'
                required
                type='date'
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='estado'>Estado del tratamiento</label>
            <div className='control'>
              <div className='select'>
                <select
                  className='select'
                  id='estado'
                  name='estado'
                  defaultValue=''
                  onChange={(e) => setEstado(e.target.value)}
                >
                  { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                </select>
              </div>
            </div>
          </div>

          <div className='field'>
            <label htmlFor='medico'>Médicos</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='medico'
                name='medico'
                options={medico}
                placeholder='Seleccionar Especialistas'
                onChange={setMedicoSelected}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='psicohosp'>Psicólogos con acceso temporal Hospital</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='psicohosp'
                name='psicohosp'
                options={psicologo}
                placeholder='Seleccionar Especialistas'
                onChange={setPsicoHospSelected}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='psicologo'>Psicólogos</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='psicologo'
                name='psicologo'
                options={psicologo}
                placeholder='Seleccionar Especialistas'
                onChange={setPsicologoSelected}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='nutricion'>Nutricionistas</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='nutricion'
                name='nutricion'
                options={nutricion}
                placeholder='Seleccionar Especialistas'
                onChange={setNutricionSelected}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='entrenamiento'>Entrenadores</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='entrenamiento'
                name='entrenamiento'
                options={entrenamiento}
                placeholder='Seleccionar Especialistas'
                onChange={setEntrenamientoSelected}
              />
            </div>
          </div>

          <div className='field'>
            <label htmlFor='mindfulness'>Mindfulness</label>
            <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='mindfulness'
                name='mindfulness'
                options={mindfulness}
                placeholder='Seleccionar Especialistas'
                onChange={setMindfulnessSelected}
              />
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
